import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/ui/cn";

const textVariants = cva("leading-relaxed", {
  variants: {
    size: {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
    },
    weight: {
      light: "font-light",
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
    },
    color: {
      default: "text-foreground",
      muted: "text-muted-foreground",
      secondary: "text-muted-foreground",
      destructive: "text-destructive",
      inherit: "",
    },
  },
  defaultVariants: {
    size: "base",
    weight: "normal",
    color: "default",
  },
});

const Text = React.forwardRef<
  HTMLParagraphElement,
  Omit<React.ComponentPropsWithoutRef<"p">, "color"> &
    VariantProps<typeof textVariants> & {
      asChild?: boolean;
    }
>(({ className, size, weight, color, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "p";
  return (
    <Comp ref={ref} className={cn(textVariants({ size, weight, color, className }))} {...props} />
  );
});
Text.displayName = "Text";

export { Text };
